export default "__VITE_ASSET__DKlhheGX__"